import { ca } from '@cian/analytics';

export function trackShowEmptyScreen() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'show_empty_view',
    label: '',
  });
}

export function trackSignInButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click',
    label: 'empty_go_to_lk',
  });
}

export function trackSearchOffersButtonClick() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click',
    label: 'empty_go_to_search',
  });
}
